var iconNames = [
    '404',
    'android',
    'appIcon',
    'arrow',
    'arrowTop',
    'attention',
    'auto24',
    'bodytypes/compact',
    'bodytypes/delivery',
    'bodytypes/electro-hybrid-gas',
    'bodytypes/limousine',
    'bodytypes/moto-chopper',
    'bodytypes/moto-classic',
    'bodytypes/moto-enduro',
    'bodytypes/moto-naked',
    'bodytypes/moto-quad',
    'bodytypes/moto-scooter',
    'bodytypes/moto-sports',
    'bodytypes/moto-tourer',
    'bodytypes/moto-touring_enduro',
    'bodytypes/offroad',
    'bodytypes/oldtimer',
    'bodytypes/roadster',
    'bodytypes/sports',
    'bodytypes/station',
    'bodytypes/van',
    'bubble',
    'bubbles',
    'car-valuation',
    'carInsertion',
    'carInsertionEdit',
    'close',
    'contract',
    'counselor',
    'delete',
    'download',
    'edit',
    'emission-badge-2',
    'emission-badge-3',
    'emission-badge-4',
    'emission-badge-5',
    'facebook',
    'favorits',
    'finance24',
    'flag/at',
    'flag/be',
    'flag/de',
    'flag/es',
    'flag/eu',
    'flag/fr',
    'flag/it',
    'flag/lu',
    'flag/nl',
    'flag/pl',
    'google',
    'googleplus',
    'heart',
    'hook',
    'hookSquare',
    'immo24',
    'info',
    'instagram',
    'ios',
    'lifestyle/familycar',
    'lifestyle/firstcar',
    'lifestyle/fourxfour',
    'lifestyle/fuelsaver',
    'lifestyle/luxury',
    'lifestyle/roadster-l',
    'location',
    'mail',
    'navigation/car',
    'navigation/caravan',
    'navigation/motocycle',
    'navigation/truck',
    'people',
    'phone',
    'pin-car-xl',
    'pin',
    'pinCar',
    'pinMoto',
    'pinterest',
    'placeholder-car',
    'placeholder-moto',
    'placeholder-truck',
    'plus',
    'print',
    'saved-search',
    'scout24',
    'search',
    'security',
    'sharing',
    'star-half',
    'star',
    't-online',
    'tip',
    'truckscout',
    'twitter',
    'vehicles',
    'whatsapp',
    'windows',
    'youtube'
];



var icons = iconNames.reduce(function(res, name) {
  res[name.toLowerCase()] = require('../icons/' + name + '.svg');
  return res;
}, {});

var proto = Object.create(HTMLElement.prototype);

proto.attachedCallback = function() {
    this.innerHTML = icons[('' + this.getAttribute('type')).toLowerCase()];
};

proto.attributeChangedCallback = function(attributeName, previousValue, value) {
    if (attributeName === 'type') {
        this.innerHTML = icons[('' + this.getAttribute('type')).toLowerCase()];
    }
};

try {
    document.registerElement('as24-icon', { prototype: proto });
} catch (e) {
    if (window && window.console) {
        window.console.warn('Failed to register CustomElement "as24-icon".', e);
    }
}

window.showcarIconNames = iconNames;



//////////////////
// WEBPACK FOOTER
// ./src/icons.js
// module id = 0
// module chunks = 0